import React, { useEffect, useState } from 'react';
import { Button } from '@zurich-primitives/button';
import { Chip } from 'app/components';
import {
  getBootstrapApp,
  getBusinessArea,
  getEmailChain,
  getService,
  setEmailChain,
  setGeneratingExtraction,
  setRegenerateExtraction,
  useAppDispatch,
  useAppSelector
} from 'app/redux';
import { ReactComponent as AddEmailIcon } from 'app/assets/Icons/AddEmail.svg';
import { ReactComponent as EraserIcon } from 'app/assets/Icons/Eraser.svg';
import { ReactComponent as RepeatIcon } from 'app/assets/Icons/Repeat.svg';
import { ReactComponent as MailIcon } from 'app/assets/Icons/Chips/Mail.svg';
import styles from './UploadedText.module.scss';

export const UploadedText: React.FC = () => {
  const dispatch = useAppDispatch();
  const currentEmailChain = useAppSelector(getEmailChain);
  const businessArea = useAppSelector(getBusinessArea);
  const service = useAppSelector(getService);
  const bootstrap = useAppSelector(getBootstrapApp);
  const services = bootstrap.services;
  const businessAreas = bootstrap.businessAreas;
  const [newEmail, setNewEmail] = useState<string>('');
  const [showNewEmailForm, setShowNewEmailForm] = useState<boolean>(false);

  const handleEraseDocument = (): void => {
    dispatch(setEmailChain(undefined));
  };

  const handleAddEmail = (): void => {
    setShowNewEmailForm((prev) => !prev);
  };

  const handleRegenerate = (): void => {
    dispatch(setGeneratingExtraction(true));
    dispatch(setRegenerateExtraction(true));
  };

  const handleSummarizeNewEmail = (): void => {
    dispatch(setEmailChain(newEmail));
    setShowNewEmailForm(false);
    handleRegenerate();
  };

  useEffect(() => {}, [newEmail]);

  return (
    <div className={styles['uploaded-text']}>
      <h3>Selected areas</h3>

      <div className={styles.areas}>
        <div className={styles.chips}>
          {businessArea !== undefined && (
            <Chip
              value={businessAreas[businessArea].name}
              id={businessArea}
              icon="Edit"
              selected
              className={styles['chip-area']}
            />
          )}
          {service !== undefined && (
            <Chip
              value={services[service].name}
              id={service}
              icon="Package"
              selected
              className={styles['chip-service']}
            />
          )}
        </div>
        <div className={styles.buttons}>
          <Button
            aria-label="Delete document"
            variant="tertiary"
            size="small"
            onClick={handleEraseDocument}
          >
            <Button.Icon>
              <EraserIcon />
            </Button.Icon>
            <Button.Label>Delete email</Button.Label>
          </Button>
          <Button
            aria-label="Upload document"
            variant="tertiary"
            size="small"
            onClick={handleAddEmail}
          >
            <Button.Icon>
              <AddEmailIcon />
            </Button.Icon>
            <Button.Label>Add new email</Button.Label>
          </Button>
          {currentEmailChain !== undefined && (
            <Button
              aria-label="Delete document"
              variant="tertiary"
              size="small"
              onClick={handleRegenerate}
            >
              <Button.Icon>
                <RepeatIcon />
              </Button.Icon>
              <Button.Label>Regenerate</Button.Label>
            </Button>
          )}
        </div>
      </div>

      {showNewEmailForm && (
        <div className={styles['new-email']} id="new-email-form">
          <div className={styles['email-summary-form']}>
            <textarea
              onChange={(e) => setNewEmail(e.target.value)}
              placeholder="Please copy and paste your claims email here"
            />
          </div>
          <Button
            onClick={handleSummarizeNewEmail}
            disabled={newEmail.length === 0}
          >
            <Button.Icon>
              <MailIcon />
            </Button.Icon>
            <Button.Label>Summarize email</Button.Label>
          </Button>
        </div>
      )}
    </div>
  );
};
